<template>
  <b-sidebar
    id="sidebar-create-direction-sector-code"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ directionSectorCode.id ? $t('Update') : $t('Create') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />
      </div>

      <b-form
        class="p-2"
        @submit.prevent="submit(hide)"
      >
        <b-form-group
          :label="$t('Direction')"
          label-for="direction-sector-direction"
        >
          <v-select
            id="direction-sector-direction"
            v-model="directionSectorCode.direction"
            :options="directionOptions"
            label="text"
            :reduce="option => option.value"
            :placeholder="$t('Select')"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Category Subject')"
          label-for="direction-sector-category-subject"
        >
          <v-select
            id="direction-sector-category-subject"
            v-model="directionSectorCode.category_subject"
            :options="categorySubjectOptions"
            label="text"
            :reduce="option => option.value"
            :placeholder="$t('Select')"
          />
        </b-form-group>

        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            :disabled="!directionSectorCode.direction || !directionSectorCode.category_subject"
          >
            {{ directionSectorCode.id ? $t('Update') : $t('Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  computed: {
    directionSectorCode() {
      return this.$store.state.directionSectorCode.directionSectorCode
    },
    directionOptions() {
      return this.$store.state.directionSectorCode.directions.map(direction => ({
        value: direction.id,
        text: `${direction.code} - ${this.$langName(direction.name)}`,
      }))
    },
    categorySubjectOptions() {
      return this.$store.state.directionSectorCode.categorySubjects.map(categorySubject => ({
        value: categorySubject.id,
        text: `${categorySubject.science_sector_code || categorySubject.code} - ${this.$langName(categorySubject.name)}`,
      }))
    },
  },
  methods: {
    clear(hide) {
      this.$store.commit('directionSectorCode/FRESH')
      hide()
    },
    submit(hide) {
      const action = this.directionSectorCode.id ? 'update' : 'create'
      this.$createSwal(this, this.directionSectorCode, `directionSectorCode/${action}`, () => {
        this.$emit('refetchData')
        this.$store.commit('directionSectorCode/FRESH')
        hide()
      })
    },
  },
}
</script>
